export default __webpack_public_path__ + "static/media/3.a9d685e6.jpg";